require('./single-dish-detail.scss');

const React = require('react');
const _findIndex = require('../../../utils/findIndex.js');
const helper = require('../../../helper/dish-helper');
const DishDetailHead = require('./dish-detail-head.jsx');
const DishPropsSelect = require('./dish-props-select.jsx');
const Counter = require('../../mui/counter.jsx');
const classnames = require('classnames');
const toastIcon = require('../../../asset/images/warning-white.svg');

import FormattedMessage from '@/intl/formatted-message';
import dishMenuMessages from '../../../intl/messages/dish-menu';
import buryingPoint, { getPageTypeFromUrl } from '../../../helper/divolte/register-divolte';
module.exports = React.createClass({
  displayName: 'SingleDishDetail',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    sameRuleDishList: React.PropTypes.array,
    onAddToCarBtnTap: React.PropTypes.func.isRequired,
    maximum: React.PropTypes.number,
    ifShowToolTip: React.PropTypes.bool,
    confirmButtonText: React.PropTypes.string,
    showMemberPriceInfo: React.PropTypes.bool,
  },
  getInitialState() {
    const { dish, sameRuleDishList } = this.props;
    const checkedRuleIds = {};
    let disabledRuleIdMap = {};
    let validateDish = dish;

    this.sameRuleList = this.getSameRuleList();
    if (sameRuleDishList) {
      let id = null;
      validateDish = sameRuleDishList.filter(item => !item.clearStatus)[0] || dish;
      validateDish.dishPropertyTypeInfos
        .filter(item => item.type === 4)
        .forEach(item => {
          id = checkedRuleIds[item.id] = item.properties[0].id;
        });

      const rulePropertyInfo = this.getRulePropertyInfo({ checkedRuleIds, id });
      disabledRuleIdMap = rulePropertyInfo.disabledRuleIdMap;
    }

    return {
      dish: validateDish.merge({ order: this.getNewDishOrder(validateDish) }),
      toast: 0,
      tipText: '',
      checkedRuleIds,
      disabledRuleIdMap,
    };
  },
  componentWillMount() {
    this.historyDishMap = {};
  },
  componentDidUpdate() {
    const { sameRuleDishList } = this.props;
    const { dish } = this.state;
    if (sameRuleDishList && dish && dish.ruleFlag) {
      this.historyDishMap[dish.ruleFlag] = dish;
    }
  },
  componentWillUnmount() {
    delete this.historyDishMap;
  },
  /**
   * 埋点购物车
   */
  buryingPointAddToCart(dish = {}) {
    try {
      const pageType = getPageTypeFromUrl();
      buryingPoint.send('AddToShoppingCart', { commodityId: dish.id || '', pageType });
    } catch (ex) {
      console.error(ex);
    }
  },
  onAddToCarBtnTap() {
    if (!this.valid()) return;
    const { onAddToCarBtnTap } = this.props;
    const { dish } = this.state;
    const dishCount = helper.getDishesCount([dish]);
    if (dishCount > 0) {
      onAddToCarBtnTap(dish, dishCount);
      this.buryingPointAddToCart(dish);
      return true;
    }

    this.showToast(<FormattedMessage {...dishMenuMessages.pleaseChooseDish} />);
    return false;
  },
  onDishItemCountChange(increment) {
    const dishForDetail = this.state.dish;
    const dishForCart = this.props.dish;
    const countForDetail = helper.getDishesCount([dishForDetail]);
    const countForCart = helper.getDishesCount([dishForCart]);
    let newCountForDetail;

    if (countForDetail === 0 && countForCart === 0) {
      // if never ordered this dish;
      newCountForDetail = dishForDetail.dishIncreaseUnit;
    } else if (countForCart === 0 && countForDetail + increment < dishForDetail.dishIncreaseUnit) {
      // if never ordered this dish and now want to order a count that is smaller thant dishIncreaseUnit;
      newCountForDetail = 0;
    } else {
      newCountForDetail = countForDetail + increment;
    }

    if (helper.isSingleDishWithoutProps(dishForDetail)) {
      this.setState({ dish: dishForDetail.set('order', newCountForDetail) });
    } else {
      this.setState({
        dish: dishForDetail.setIn(['order', 0, 'count'], newCountForDetail),
      });
    }
  },
  /**
   * 校验
   * 增加必选校验
   * @return boolean
   */
  valid() {
    let res = true;
    const { dish } = this.state;
    if (!dish || !dish.hasOwnProperty('order') || !Array.isArray(dish.order) || !dish.order[0]) return res; // 不满足条件都默认校验通过
    const { dishPropertyTypeInfos } = dish.order[0];
    if (!dishPropertyTypeInfos || !Array.isArray(dishPropertyTypeInfos)) return res;
    for (let i = 0, l = dishPropertyTypeInfos.length; i < l; i++) {
      const { isMandatory, properties, name } = dishPropertyTypeInfos[i];
      if (isMandatory === 1) {
        // 选项中没有一个被设置为选中
        if (!properties.some(pro => pro.isChecked)) {
          this.showToast(`请选择${name}`, 1000);
          res = false;
          break;
        }
      }
    }
    return res;
  },
  onSelectPropsOption(propData, optionData) {
    const dishForDetail = this.state.dish;
    let propIdx = -1;
    switch (propData.type) {
      case 1:
        propIdx = _findIndex(dishForDetail.order[0].dishPropertyTypeInfos, {
          id: propData.id,
        });
        this.setState({
          dish: dishForDetail.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], options =>
            options.flatMap(option => {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              } else if (option.id !== optionData.id && option.isChecked === true) {
                return option.set('isChecked', false);
              }
              return option;
            }),
          ),
        });
        break;
      case 3:
        propIdx = _findIndex(dishForDetail.order[0].dishPropertyTypeInfos, {
          id: propData.id,
        });
        this.setState({
          dish: dishForDetail.updateIn(['order', 0, 'dishPropertyTypeInfos', propIdx, 'properties'], options =>
            options.flatMap(option => {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              }
              return option;
            }),
          ),
        });
        break;
      case -1: // this is a client workround for ingredientsData, we don't have this value of type on serverside
        this.setState({
          dish: dishForDetail.updateIn(['order', 0, 'dishIngredientInfos'], options =>
            options.flatMap(option => {
              if (option.id === optionData.id) {
                return option.set('isChecked', !option.isChecked);
              }
              return option;
            }),
          ),
        });
        break;
      default:
    }
  },
  getVirtualDish() {
    const { dish } = this.props;
    const virtualDish = Object.assign({}, dish, {
      marketPrice: 0,
      dishPropertyTypeInfos: [],
      dishIngredientInfos: [],
      isVirtualDish: true,
      clearStatus: true,
      order: 0,
      ruleFlag: null,
    });
    return virtualDish;
  },
  getDishPropertyTypeInfos(infos) {
    const mutabledInfo = infos.asMutable({ deep: true });
    return mutabledInfo.map(info => {
      if (info.type === 4) {
        info.properties.forEach(property => Object.assign(property, { isChecked: true }));
      }
      return info;
    });
  },
  getNewDishOrder(dish) {
    if (helper.isSingleDishWithoutProps(dish)) {
      return dish.dishIncreaseUnit || 1;
    }

    return [
      {
        count: dish.dishIncreaseUnit || 1,
        dishPropertyTypeInfos: dish.dishPropertyTypeInfos,
        dishIngredientInfos: dish.dishIngredientInfos,
      },
    ];
  },
  getSameRuleList() {
    // 多规格菜品合并
    const { sameRuleDishList } = this.props;
    const rules = [];

    if (!sameRuleDishList) {
      return rules;
    }

    sameRuleDishList.forEach(dish => {
      const dishRules = dish.dishPropertyTypeInfos.filter(property => property.type === 4);
      dishRules.forEach((rule, index) => {
        const ruleItem = rules[index] || {
          name: rule.name,
          list: [],
          id: rule.id,
        };
        ruleItem.list = ruleItem.list.concat(rule.properties);
        rules[index] = ruleItem;
      });
    });
    return rules;
  },
  getRulePropertyInfo(args) {
    const { checkedRuleIds } = args;
    const { sameRuleDishList } = this.props;
    const ruleList = this.sameRuleList;
    const flags = sameRuleDishList.map(dish => dish.ruleFlag);
    const disabledRuleIdMap = {};
    if (ruleList.length === 1) {
      return { checkedRuleIds, disabledRuleIdMap };
    }

    const rulePropertiesForEach = func => {
      ruleList.forEach((rule, index) => {
        const { list } = rule;
        list.forEach(property => {
          func(rule, property);
        });
      });
    };

    const matchFlag = (str, searchValue) => `-${str}-`.indexOf(`-${searchValue}-`) > -1;
    // clear invalid checked property id
    const predictableDishFlags = flags.filter(flag => matchFlag(flag, args.id));
    rulePropertiesForEach((rule, property) => {
      const exist = predictableDishFlags.filter(flag => matchFlag(flag, property.id)).length > 0;
      if (!exist) {
        const checkedId = checkedRuleIds[rule.id];
        if (checkedId === property.id) {
          checkedRuleIds[rule.id] = -1;
        }
      }
    });

    // predict next step valid dish
    const ruleIds = Object.keys(checkedRuleIds);
    const predictableDishFlagMap = {};
    ruleIds.forEach(ruleId => {
      const subCheckedRuleIds = [];
      ruleIds.forEach(_ruleId => {
        if (ruleId !== _ruleId && checkedRuleIds[_ruleId] !== -1) {
          subCheckedRuleIds.push(checkedRuleIds[_ruleId]);
        }
      });

      predictableDishFlagMap[ruleId] = flags.filter(flag => {
        let matched = true;
        subCheckedRuleIds.forEach(item => {
          matched &= flag.indexOf(item) > -1;
        });
        return matched;
      });
    });

    rulePropertiesForEach((rule, property) => {
      const exist = predictableDishFlagMap[rule.id].filter(flag => matchFlag(flag, property.id)).length > 0;
      if (!exist) {
        disabledRuleIdMap[property.id] = true;
      }
    });
    return { checkedRuleIds, disabledRuleIdMap };
  },
  setDishRuleProps(categoryId, id) {
    const { checkedRuleIds } = this.state;
    const { sameRuleDishList } = this.props;
    const nextCheckedRuleIds = Object.assign({}, checkedRuleIds);
    const ruleIds = [];

    nextCheckedRuleIds[categoryId] = id;
    for (const name in nextCheckedRuleIds) {
      if (nextCheckedRuleIds.hasOwnProperty(name)) {
        ruleIds.push(nextCheckedRuleIds[name]);
      }
    }

    const ruleFlag = ruleIds.sort().join('-');
    const nextDish = sameRuleDishList.filter(item => item.ruleFlag === ruleFlag)[0];
    const historyDish = this.historyDishMap[ruleFlag];
    const nextState = this.getRulePropertyInfo({
      id,
      nextDish,
      checkedRuleIds: nextCheckedRuleIds,
    });

    if (historyDish) {
      nextState.dish = historyDish;
    } else if (nextDish) {
      nextState.dish = nextDish.set('order', this.getNewDishOrder(nextDish));
    } else {
      nextState.dish = this.getVirtualDish();
    }
    this.setState(nextState);
  },
  buildDishCounter(dish) {
    if (dish.isVirtualDish) {
      return false;
    }

    if (dish.clearStatus) {
      return (
        <span className="dish-detail-addtocarta-soldout">
          <FormattedMessage {...dishMenuMessages.soldout} />
        </span>
      );
    }

    return (
      <Counter
        step={dish.stepNum || 1}
        maximum={this.props.maximum}
        minimum={dish.dishIncreaseUnit || 1}
        count={helper.getDishesCount([dish])}
        onCountChange={(count, increment) => this.onDishItemCountChange(increment)}
        dishItem={dish}
        ifShowToolTip={this.props.ifShowToolTip}
        flag
      />
    );
  },
  showToast(text, time) {
    const _time = time === undefined || time === null ? 3000 : time;
    this.setState({ toast: 1, tipText: text });
    setTimeout(() => {
      this.setState({ toast: 0, tipText: '' });
    }, _time);
  },
  render() {
    const { dish, checkedRuleIds, disabledRuleIdMap } = this.state;
    const { confirmButtonText = <FormattedMessage {...dishMenuMessages.addToShoppingCart} />, showMemberPriceInfo } = this.props;

    return (
      <div className="single-dish-detail o-flex o-flex--column">
        <div className="dish-detail-close--modify" onTouchTap={this.props.onCloseBtnTap}>
          <a className="btn-close" />
        </div>
        <DishDetailHead dish={dish} showMemberPriceInfo={showMemberPriceInfo} onCountChange={this.onDishItemCountChange} />
        <DishPropsSelect
          showMemberPriceInfo={showMemberPriceInfo}
          onSelectPropsOption={this.onSelectPropsOption}
          dish={dish}
          checkedRuleIds={checkedRuleIds}
          disabledRuleIdMap={disabledRuleIdMap}
          sameRuleList={this.sameRuleList}
          onDishRuleChecked={this.setDishRuleProps}
        />
        <div className="dish-detail-addtocarta o-flex__fixed o-border--top">
          {this.buildDishCounter(dish)}
          <div style={{ flex: 1 }}>
            <button
              className={classnames('o-btn o-btn--linear', {
                'o-btn--grey': dish.clearStatus,
              })}
              onTouchTap={evt => {
                evt.preventDefault();
                if (dish.clearStatus) {
                  return false;
                }
                return this.onAddToCarBtnTap();
              }}
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
        {this.state.toast === 1 && (
          <div className="c-toast">
            <div className="c-toast__content">
              <img src={toastIcon} style={{ width: 28 }} alt="" />
              {this.state.tipText}
            </div>
          </div>
        )}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/detail/single-dish-detail.jsx